import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ChangesService {
    public changed = false;
/*    public isAvr = false;*/
}
